//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { PurchaseOption } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { WIDTH_CHECKBOX } from '@campaigns/constants/sampling/SamplingCampaignRequestConstants';
import { TableDataCell } from '@components/organisms/table/TableDataCell';
import { TableRow } from '@components/organisms/table/TableRow';
import { RadioGroup } from '@components/primitives/radio-group/RadioGroup';

import { PrepaidPurchaseOptionsTableRowContent } from './PrepaidPurchaseOptionsTableRowContent';

interface PrepaidPurchaseOptionsTableRowEditableProps {
  purchaseOption: PurchaseOption;
}

export const PrepaidPurchaseOptionsTableRowEditable = ({
  purchaseOption,
}: PrepaidPurchaseOptionsTableRowEditableProps) => {
  return (
    <TableRow>
      <CheckboxCell scope='row'>
        <RadioGroup.Item
          id={purchaseOption.opportunityId}
          value={purchaseOption.opportunityId}
        >
          <RadioGroup.Indicator />
        </RadioGroup.Item>
      </CheckboxCell>
      <PrepaidPurchaseOptionsTableRowContent purchaseOption={purchaseOption} />
    </TableRow>
  );
};

const CheckboxCell = styled(TableDataCell)`
  ${WIDTH_CHECKBOX}
`;
